import { Address, LanguageText, StandardService } from "../shared";

export interface VshClientUser {
  id: string;
  clientId: string;
  userId: string;
  status: ClientUserStatus;
  roleCode: ClientUserRole;
  accessToClientZone: boolean;
  authorizedToSendTickets: boolean;
  cloudDnsEnabled: boolean;
  cdnEnabled: boolean;
  cloudMailEnabled: boolean;
  client: ClientUserClient;
  email: string;
  fullName: string;
  firstName: string;
  lastName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  countryCallingCode?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  phoneNumber?: any;
  smsNotifications: boolean;
  language: ClientLanguage;
  accessToAllServers: boolean;
  serverIdAccessList: string[];
}

export interface BillingPeriod {
  id: string;
  created: string;
  name: LanguageText;
  discount: number;
  monthLength: number;
}

export interface ConnectedService {
  id: string;
  clientId: string;
  clientZoneStatus: string;
  standardService: StandardService;
  serviceType: string;
  serviceName: string;
  serviceIdentification: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  oneTimePrice?: any;
  monthPriceDiscounted: number;
  currencyId: string;
  activationDate: string;
  billingPeriod: BillingPeriod;
}

interface ClientUserClient {
  id: string;
  companyName: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  webUrl?: any;
  status: string;
  hasAccessToServerPark: boolean;
  cloudDnsEnabled: boolean;
  companyNumber: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  vatNumber?: any;
  secureCommunication: boolean;
  connectedServiceList: ConnectedService[];
  vatCountryId: string;
  vatMode: string;
  vatRate: number;
  creditVat: number;
  invoicesTotalDue: number;
  currencyId: string;
  languageId: string;
  invoiceAddress: Address;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  deliveryAddress?: any;
  invoiceVariableSymbol: number;
  feeVariableSymbol: number;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  salesman?: any;
}

export interface ClientLanguage {
  id: string;
  name: string;
}

export enum ClientUserRole {
  Manager = 'MANAGER',
  FinancialUser = 'FINANCIAL_USER',
  TechnicalUser = 'TECHNICAL_USER'
}

export enum ClientUserStatus {
  Active = 'ACTIVE',
  WaitingForAuthorization = 'WAITING_AUTHORIZATION',
  BeingDeleted = 'BEING_DELETED'
}

export const clientUserRoles = Object.values(ClientUserRole);
